import gpt from '@tkww/xo.ads.gpt';
import { getCookieValue, getPageViewProps } from '../permutive';

const ajsUserId = getCookieValue('ajs_user_id') ?? '';
const ajsAnonymousId = getCookieValue('ajs_anonymous_id') ?? '';

// Per the Ads documentation: This preset configures the adUnit naming convention based on the data in XO.metadata
gpt.initialize({
  ...new gpt.configPresets.TheKnotLegacy(),
  permutiveConfig: {
    enable: true,
    publicApiKey: process.env.PERMUTIVE_PUBLIC_API_KEY,
    workspaceId: process.env.PERMUTIVE_WORKSPACE_ID,
    pageViewProps: getPageViewProps(),
    identifyProps: {
      userId: ajsUserId,
      anonymousId: ajsAnonymousId,
    },
  }
});
